<template>
  <div class="nav-panel">
    <div class="nav-panel__right active-menu">
      <ul class="nav-panel__links">
        <li class="nav-panel__link-item" :class="{'nav-panel__link-item--active': $route.name === 'members'}">
          <router-link :to="{name: 'members'}">
            <span @click="clearMembersStore" id="menu-members">{{ trans.get('top_bar.members') }}</span>
          </router-link>
        </li>
        <li class="nav-panel__link-item" :class="{'nav-panel__link-item--active': $route.name === 'match_game'}">
          <router-link :to="{name: 'match_game'}">
            <span id="menu-match-game">{{ trans.get('top_bar.match_game') }}</span>
          </router-link>
        </li>
        <li class="nav-panel__link-item" :class="{'nav-panel__link-item--active': $route.name === 'chat'}">
          <router-link :to="{name: 'chat'}">
            <span id="menu-chat">{{ trans.get('top_bar.messages') }}</span>
            <chat-unread-messages-component></chat-unread-messages-component>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="nav-panel__left">
      <ul class="nav-panel__links" v-if="true">
        <li class="nav-panel__link-item d-none d-md-block">
          <router-link :to="{name: 'more-settings'}">
            <i class="demo-icon icon-settings-o" aria-hidden="true"></i>
          </router-link>
        </li>
        <li class="nav-panel__link-item">
          <router-link :to="{name: 'user'}">
            <span>{{ trans.get('top_bar.profile') }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClearMembersStore from '../../../front/views/elements/ClearMembersStore';

export default {
  mixins: [ClearMembersStore],
  data() {
    return {
      //csrf token
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  mounted() {
  }
};
</script>
